import type { ConfigureIntegrationResult } from '@cli-types/next-adapter/runtime.js'
import { appendEnvVars } from '@cli-utils/files.js'
import { collectResendConfig } from './collect-resend-config.js'

export async function promptResendConfig(cwd: string): Promise<ConfigureIntegrationResult> {
  const collected = await collectResendConfig(cwd)
  const envResult = appendEnvVars(cwd, collected.sections, collected.overwriteKeys)

  return {
    configured: true,
    addedEnvKeys: envResult.added,
    updatedEnvKeys: envResult.updated
  }
}
